'use client'

import Image from 'next/image'
import { type SocialLinks } from '../interface/AuthorData'
import styles from './introSection.module.scss'

interface SocialLinkProps {
  socialLinks: SocialLinks
}

const socialMediaLogo = {
  email: 'https://acko-cms.ackoassets.com/mail_c96b3722d4.svg',
  instagram: 'https://acko-cms.ackoassets.com/instagram_67ad2c6409.svg',
  linkedin: 'https://acko-cms.ackoassets.com/linkedin_a5c734edaa.svg',
  twitter: 'https://acko-cms.ackoassets.com/twitter_cee5ca456c.svg',
  youtube: 'https://acko-cms.ackoassets.com/you_Tube_796206ffd0.svg',
  facebook: 'https://acko-cms.ackoassets.com/facebook_5f3e03d289.svg',
}

const SocialLinksComponent: React.FC<SocialLinkProps> = ({ socialLinks }) => {
  const shortenedSocialLinks = Object.keys(socialLinks).slice(0, 4)

  return (
    <div className={styles.socialLinkRootContainer}>
      {Object.keys(socialLinks).map(item => (
        <a href={socialLinks[item]} className={styles.logoContainerDesktop} target="_blank" rel="noopener" key={item}>
          <Image src={socialMediaLogo[item]} alt={item} loading="lazy" fill />
        </a>
      ))}
      {shortenedSocialLinks.map(item => (
        <a href={socialLinks[item]} className={styles.logoContainerMweb} target="_blank" rel="noopener" key={item}>
          <Image src={socialMediaLogo[item]} alt={item} loading="lazy" fill />
        </a>
      ))}
    </div>
  )
}

export default SocialLinksComponent
